import type { RouteRecordRaw } from 'vue-router';

import { DEFAULT_HOME_PATH } from '#/constants';

/** 基本路由，这些路由是必须存在的 */
const coreRoutes: RouteRecordRaw[] = [
  {
    meta: {
      title: 'Root',
    },
    name: 'Root',
    path: '/',
    redirect: DEFAULT_HOME_PATH,
  },
  {
    name: 'Home',
    path: '/home',
    component: () =>
      import(/* webpackChunkName: "redirectWechat" */ '#/views/home/index.vue'),
  },
  {
    name: 'hub-component', // 1.5版本小程序 H5 中转页
    path: '/hub-component',
    component: () =>
      import(
        /* webpackChunkName: "redirectWechat-component" */ '#/views/hub-component/index.vue'
      ),
  },
  {
    name: 'hub', // 1.0版本小程序 H5 中转页
    path: '/hub',
    component: () =>
      import(/* webpackChunkName: "redirectWechat" */ '#/views/hub/index.vue'),
    beforeEnter: (to, _, next) => {
      // 带的参
      let queryString = '';
      if (to.query) {
        for (const k in to.query) {
          queryString += `${k}=${to.query[k]}&`;
        }
      }

      // 判断是否为1.5版本的面试和候选人
      const c = String(to?.query?.c || '');

      if (['1', '2', '3', 'G', 'H', 'I'].some((item) => c.startsWith(item))) {
        return next(`/hub-component?${queryString}`);
      }

      next();
    },
  },
  {
    name: 'redirect-wechat',
    path: '/redirect-wechat',
    redirect: '/redirect-wechat/a',
    children: [
      {
        name: 'a',
        path: 'a',
        component: () =>
          import(
            /* webpackChunkName: "redirectWechat" */ '#/views/hub/redirectWechat.vue'
          ),
      },
      {
        name: 'component',
        path: 'component',
        component: () =>
          import(
            /* webpackChunkName: "redirectWechat-component" */ '#/views/hub-component/redirectWechat.vue'
          ),
      },
    ],
  },
];

export { coreRoutes };
